import { AxiosError, AxiosResponse } from 'axios';
import { getApi } from './api';

const URL = '/image';

const allowedErrors = [404];

const create = async (file: File) => {
  const formData: FormData = new FormData();
  formData.append(`file`, file, file.name);

  const api = await getApi();
  return api
    .post<{ id: number }>(`${URL}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => response.data.id);
};

const update = async (id: number, file: File) => {
  const formData: FormData = new FormData();
  formData.append(`file`, file, file.name);

  const api = await getApi();
  return api
    .put<void>(`${URL}/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => response.data);
};

const get = async (path: string) => {
  const api = await getApi({ ignoreErrorStatuses: allowedErrors });
  return api
    .get(path, { responseType: 'blob' })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => {
      if (allowedErrors.includes(error.response?.status || 0)) {
        return null;
      }
      throw error;
    });
};

export const imagesService = {
  create,
  update,
  get,
};
